export default __webpack_public_path__ + "static/media/FINancials_Junior_GM_LVL_03.278d9a17.mp4";